import Vue from 'vue'
import * as VueSecureHTML from 'vue-html-secure'

Vue.use(VueSecureHTML)
